import { Tooltip } from 'components/Tooltip';
import { Loaders } from 'components/Loader';
import { PanelBox } from 'components/PanelBox';
import { useEffect } from 'react';
import { VideoCard } from 'components/VideoCard';
import { Box, Button } from '@mui/material';
import { useHomeList } from './useHomeList';
import { CollapseRow } from 'components/CollapseRow';
import { DragNDropList } from 'components/DragNDropList';
import { TreeConectors } from 'components/TreeConectors';
import { useTableStore } from 'components/TableWithCheck/selectTableStore';
import { useAppHomeStore } from 'store/appHomeStore';
import { useLoadingStore } from 'store/loadingStore';
import { DeleteModalButton } from 'components/Modal/DeleteModalButton';
import { VideoOrSerieModal } from 'components/TableWithCheck/VideoOrSerieModal';
import { thumbAdornment } from 'constants/homeApp';
import { getImageURL } from 'utils/tableListFormat';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export const HomeList = () => {
  const {
    selectedItems,
    updateSelectedItemsByList,
    deleteSelectedItemsByListAndId,
  } = useTableStore();
  const { loading, getHomeListData, setData } = useHomeList();
  const { appList, addAppListItem, setAppList } = useAppHomeStore();
  const savingHomeApp = useLoadingStore(state => state.savingHomeApp);
  const maxItemsLimitExeeded = appList.length >= 20;

  useEffect(() => {
    getHomeListData();
  }, [getHomeListData]);

  useEffect(() => {
    return () => {
      setData([]);
      setAppList([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PanelBox
      id="home-list"
      title="Home list"
      description="Listas abaixo do carrossel principal"
      count={{
        selectedLength: appList.length,
        maxLength: 20,
        template: '$count de $max adicionada(s)',
      }}>
      {loading && <Loaders.TableInfo sx={{ padding: 100 }} />}
      <DragNDropList
        onChange={list => {
          setAppList(list.map(i => i.data));
        }}
        items={useAppHomeStore.getState().appList.map(list => ({
          id: list.id,
          data: list,
          component: (
            <CollapseRow
              key={list.id}
              initialTitleValue={list.title}
              edit={list.edit}
              list={selectedItems?.[list.id]}
              listId={list.id}
              disabled={savingHomeApp}
              count={{
                selectedLength: selectedItems?.[list.id]?.length,
                maxLength: 40,
                minLength: 1,
              }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'min-content auto',
                  paddingLeft: '6px',
                }}>
                <TreeConectors.Column
                  length={selectedItems?.[list.id]?.length}
                />
                <Box display="grid">
                  <DragNDropList
                    onChange={listContent => {
                      updateSelectedItemsByList(
                        list.id,
                        listContent.map(i => i.data)
                      );
                    }}
                    items={
                      selectedItems?.[list.id]?.map(i => ({
                        id: i.contentId || i.id,
                        data: i,
                        component: (
                          <VideoCard.Root key={i.id}>
                            <VideoCard.Image
                              variant="vertical"
                              image={getImageURL(i, 'VERTICAL')}
                              size="small">
                              <VideoCard.CornerAdornment
                                name={
                                  thumbAdornment[
                                    i?.type || i?.contentType || 'VIDEO'
                                  ]
                                }
                              />
                            </VideoCard.Image>
                            <VideoCard.DescriptionDetail {...i} />
                            <VideoCard.ActionsContainer>
                              <DeleteModalButton
                                disabled={loading || savingHomeApp}
                                itemName={`${list.title}: ${i.title}`}
                                itemSubject={'Home list'}
                                onDelete={() =>
                                  deleteSelectedItemsByListAndId(list.id, i.id)
                                }
                              />
                              <VideoCard.ActionButton
                                action="move"
                                onClick={() => {}}
                              />
                            </VideoCard.ActionsContainer>
                          </VideoCard.Root>
                        ),
                      })) || []
                    }
                  />
                </Box>
              </Box>
              <Box display="grid" justifyContent="end">
                <VideoOrSerieModal
                  allowCollections
                  count={{
                    selectedLength: selectedItems?.[list.id]?.length,
                    maxLength: 40,
                    minLength: 1,
                  }}
                  limitExceeded={selectedItems?.[list.id]?.length >= 40}
                  itemName={list.title}
                  listId={list.id}
                />
              </Box>
            </CollapseRow>
          ),
        }))}
      />
      <Box
        sx={{
          display: 'grid',
          justifyContent: 'flex-end',
          padding: 2,
        }}>
        <Tooltip.Info
          title="Limite de itens alcançado"
          description="Exclua itens para adicionar mais"
          show={maxItemsLimitExeeded}>
          <Button
            variant="contained"
            disabled={loading || savingHomeApp}
            onClick={maxItemsLimitExeeded ? undefined : addAppListItem}
            startIcon={<FormatListBulletedIcon />}>
            Adicionar Lista
          </Button>
        </Tooltip.Info>
      </Box>
    </PanelBox>
  );
};
